import { Component, ElementRef, Renderer2 } from '@angular/core';
import { Input } from '@angular/core';
import { OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { NgFor } from '@angular/common';
import { ChartHeaderComponent } from '../chart-header/chart-header.component';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartsCommonFunctions } from '../chartsCommonFunctions';
import { NgIf } from '@angular/common';
 import { MatTooltipModule } from '@angular/material/tooltip';
 import { NgClass } from '@angular/common';
import { environment } from 'src/environments/environment';
import { RetailerProfileComponent } from 'src/app/profiles/retailer-profile/retailer-profile.component';
import { ListProfileComponent } from 'src/app/profiles/list-profile/list-profile.component';

interface category{
  title:string,
  products: product[],

}

interface product{
  logo:string | null,
  link:string,
  name:string,
  first_seen:string,
  last_seen:string,
  vendor_rcl:string,
  client_percent?:number
}

@Component({
  standalone:true,
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
  imports: [
    NgOptimizedImage,
    NgFor,
    ChartHeaderComponent,
    NgIf,
    MatTooltipModule,
    NgClass
  ]
})
export class ProductListComponent {
  constructor(private http:HttpClient,
    private route:ActivatedRoute,
    private router: Router,
    private common:ChartsCommonFunctions,
    private elementRef:ElementRef,
    private renderer:Renderer2,
    private retailerprofile: RetailerProfileComponent,
    private listprofile: ListProfileComponent,
  ) {}
@Input() rcl:any = ''
@Input() model:any = ''
@Input() chartId:any = ''
@Input() retailer:any = ''

showData:boolean = false
profile:any = '';
current_list:any = '';
plotId:any = ''

text_elements:any = {
header:"Analytics & Tracking",
subheader:"Analytics & Tracking suppliers to UK500 retailers ",
caption:"caption",
source:"BuiltWith (data), RetailX (analysis)",
chartId:this.chartId
}


isMobile = window.innerWidth <= 767

data: category = { title: '', products: [] };



ngOnInit() {
this.getData()

}

getData() {
  this.plotId = `#plot${this.chartId}`
  this.common.isIframe(this.elementRef, this.renderer)
  let currentPath = this.route.snapshot.url[0].path


  let url = `${environment.backend_base}main/visualizations/get_product_visualization_data/`
  let payload = {'rcl_id':this.rcl, 'model':this.model}
  this.http.post(url, payload).subscribe((response:any) => {
    this.data = response.data

    if (currentPath === 'shared' || currentPath === 'saved-charts') {
    let url = `${environment.backend_base}main/visualizations/get_public_chart_metadata/`
    let payload = {'rcl': this.rcl}

    this.http.post(url, payload).subscribe((response: any) => {
        this.profile = response.profile
        this.current_list = response.profile.current_list

      })
    } else if (!this.retailer) {

      this.profile = this.listprofile
      this.current_list = this.profile.listProfile.current_list


    } else if (currentPath !== 'shared' && currentPath !== 'saved-charts') {

      this.profile = this.retailerprofile.retailerProfile
      this.current_list = this.profile.current_list

    }


    this.text_elements = this.common.getTextElements(response.data.text_elements, this.profile)
    this.text_elements.chartId = this.chartId
    this.showData = true
  }
  )
}

classchoice(){

  if (this.data.products.length < 9){
    return "products-container-1"
  }
  else if (this.data.products.length < 18 || this.isMobile){
    return "products-container-2"
  }
  else{
    return "products-container-3"
  }

  /*if (this.data.length===1){
    return "category-container-1"
  }
  else if (this.data.length===2){
    return "category-container-2"
  }
  else if (this.data.length===3){
    return "category-container-3"
  }
  else{
    return "category-container-4"
  }*/
}

getTooltip(product:product) {
  let tooltip = `First observed ${product.first_seen}; Last checked ${product.last_seen}`
  if (this.profile.listprofile) {
    //Tooltip: add "list_label_name coverage: n%"
    tooltip = tooltip+` ${this.current_list.label} coverage: ${product.client_percent} %`
  }
  return tooltip
}

redirectToVendor(product:product) {

  let url = `${environment.frontend_base}profile?id=${product.vendor_rcl}`
  window.location.href = url
}

}
